import { Paper } from 'shared/ui/paper'
import { Skeleton as SkeletonLib } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const Skeleton = () => {
  return (
    <Paper
      padding={[12, 14]}
      className={s.container}
    >
      <div className={s.header}>
        <SkeletonLib
          width={150}
          height={22}
          borderRadius={12}
        />

        <SkeletonLib
          height={18}
          width={80}
          borderRadius={12}
        />

        <SkeletonLib
          height={20}
          width={150}
          borderRadius={12}
          className={s.tag}
        />
      </div>

      <div className={s.list}>
        <SkeletonLib
          height={18}
          borderRadius={16}
        />

        <SkeletonLib
          height={18}
          borderRadius={16}
        />

        <SkeletonLib
          height={18}
          borderRadius={16}
        />

        <SkeletonLib
          height={18}
          borderRadius={16}
        />
      </div>

      <SkeletonLib
        height={16}
        borderRadius={16}
      />
    </Paper>
  )
}
